import { gql } from '__generated__'

export const RecruiterMe = gql(/* GraphQL */ `
    query RecruiterMe {
        recruiterMe {
            id
            isAdmin
        }
    }
`)

export const AdminGetRecruiters = gql(/* GraphQL */ `
    query AdminGetRecruiters {
        adminGetRecruiters {
            id
            isAdmin
            userId
            user {
                id
                firstName
                lastName
                preferredName
                email
                isActive
            }
            lastLogin
        }
    }
`)

export const AddRecruiter = gql(/* GraphQL */ `
    mutation AddRecruiter(
        $email: String!
        $firstName: String!
        $lastName: String!
    ) {
        addRecruiter(
            email: $email
            firstName: $firstName
            lastName: $lastName
        ) {
            success
            message
        }
    }
`)

export const EditRecruiter = gql(/* GraphQL */ `
    mutation EditRecruiter(
        $recruiterId: ID!
        $email: String!
        $firstName: String!
        $lastName: String!
    ) {
        editRecruiter(
            recruiterId: $recruiterId
            email: $email
            firstName: $firstName
            lastName: $lastName
        ) {
            success
            message
        }
    }
`)

export const SetRecruiterActive = gql(/* GraphQL */ `
    mutation SetRecruiterActive($recruiterId: ID!, $isActive: Boolean!) {
        setRecruiterActive(recruiterId: $recruiterId, isActive: $isActive) {
            success
            message
        }
    }
`)

export const SetRecruiterAdmin = gql(/* GraphQL */ `
    mutation SetRecruiterAdmin($recruiterId: ID!, $isAdmin: Boolean!) {
        setRecruiterAdmin(recruiterId: $recruiterId, isAdmin: $isAdmin) {
            success
            message
        }
    }
`)
